// extracted by css-extract-rspack-plugin
export default {"cls1":"SubtopicSection-cls1_FwY","cls2":"SubtopicSection-cls2_oHF SubtopicSection-cls1_FwY"};